import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const tiltIn: gsapTimelineFunc = (target) => {
  return gsap.timeline().fromTo(
    target,
    {
      opacity: 0,
      duration: 0,
      rotateY: 20,
      rotateX: 35,
      skewX: -35,
      skewY: 10,
      translateX: '100%',
      translateY: '-100%',
      ease: Power1.easeOut,
    },
    {
      opacity: 1,
      duration: 1,
      rotateY: 0,
      rotateX: 0,
      skewX: 0,
      skewY: 0,
      translateX: 0,
      translateY: 0,
    }
  );
};
